export default __webpack_public_path__ + "static/media/ods7.79505df2.svg";